export const PARTNER_COST_UPLOAD = 'PARTNER_COST_UPLOAD'
export const PARTNER_COST_UPLOAD_FAIL = 'PARTNER_COST_UPLOAD_FAIL'
export const PARTNER_COST_UPLOAD_SUCCESS = 'PARTNER_COST_UPLOAD_SUCCESS'

export const partnerCostUpload = (data) => {
    return {
        type: PARTNER_COST_UPLOAD,
        data
    }
}

export const partnerCostUploadFail  = (data) => {
    return {
        type: PARTNER_COST_UPLOAD_FAIL,
        data
    }
}
export const partnerCostUploadSuccess = (data) => {
    return {
        type: PARTNER_COST_UPLOAD_SUCCESS,
        data
    }
}

export const PARTNER_COST_DATA_DOWNLOAD_REQUEST = 'PARTNER_COST_DATA_DOWNLOAD_REQUEST'
export const PARTNER_COST_DATA_DOWNLOAD_FAILURE = 'PARTNER_COST_DATA_DOWNLOAD_FAILURE'
export const PARTNER_COST_DATA_DOWNLOAD_SUCCESS = 'PARTNER_COST_DATA_DOWNLOAD_SUCCESS'

export const downloadPartnerCostExcelRequest = () => {
    return {
        type: PARTNER_COST_DATA_DOWNLOAD_REQUEST
    }
}

export const downloadPartnerCostExcelFail  = (data) => {
    return {
        type: PARTNER_COST_DATA_DOWNLOAD_FAILURE,
        data
    }
}
export const downloadPartnerCostExcelSuccess = (data) => {
    return {
        type: PARTNER_COST_DATA_DOWNLOAD_SUCCESS,
        data
    }
}


export const PARTNER_COST_DOWNLOAD_TEMPLATE_REQUEST = 'PARTNER_COST_DOWNLOAD_TEMPLATE_REQUEST'
export const PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_FAILURE = 'PARTNER_COST_DOWNLOAD_TEMPLATE_FAILURE'
export const PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_SUCCESS = 'PARTNER_COST_DOWNLOAD_TEMPLATE_SUCCESS'

export const partnerCostTemplateDownloadRequest = () => {
    return {
        type: PARTNER_COST_DOWNLOAD_TEMPLATE_REQUEST
    }
}

export const partnerCostTemplateDataDownloadFailure  = (data) => {
    return {
        type: PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_FAILURE,
        data
    }
}
export const partnerCostTemplateDataDownloadSuccess = (data) => {
    return {
        type: PARTNER_COST_DATA_DOWNLOAD_TEMPLATE_SUCCESS,
        data
    }
}
